import gql from "graphql-tag";

const ADD_FAVORITE = gql`
  mutation addFavorite($customer: String!) {
    addFavorite(customer: $customer)
  }
`;

export default ADD_FAVORITE;
